export default {"src":"/_next/static/media/application_read.58649b77.svg","height":16,"width":16};